import backgroundPrintFunc from 'pxc-editor-material-svg-rendering/backgroundPrintFunc';
import { OUTPUT_PAGE_IMAGE_FILE_NAME } from '@/constants';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
import { urlDataToBlob, saveToDevice } from '@/helpers';
import { setShowLoader } from '@/actions/main';

export const handlePrintClick = () => (dispatch, getState) => {
  const { core: { pagesOrder, pages, paperColor, isContentPlacingDebugging, isDebuggingGrid } } = getState();
  const { printParameters: materialPrintParameters, type: materialType } = getBuildedMatfileTemplate();

  dispatch(setShowLoader(true));
  backgroundPrintFunc(
    pagesOrder,
    {},
    { pages, materialPrintParameters, materialType, paperColor, isContentPlacingDebugging, isDebuggingGrid },
    ({ imageUrlData }) => {
      urlDataToBlob(imageUrlData).then(blob => {
        saveToDevice(blob, OUTPUT_PAGE_IMAGE_FILE_NAME);
      });
    },
    () => {
      dispatch(setShowLoader(false));
    },
  );
};
